exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".required-remark[data-v-3f69fa7e]{margin-bottom:0.08333rem;font-size:0.07292rem}.required-remark .require-icon[data-v-3f69fa7e]{color:#db4a4a;margin-right:0.05208rem}.error-table[data-v-3f69fa7e]{border:solid 0.00521rem #db4a4a}.required[data-v-3f69fa7e]::before{content:'*';color:red}\n", ""]);

// exports
